import { Modal } from 'antd';
import styled from 'styled-components';

export const FixedAssetLedgerContainer = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FixedAssetLedgerWrapper = styled.div<{
  listdata: number;
}>`
  .fixed-asset-ledger_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
    flex-wrap: wrap;

    .fixed-asset-ledger_header-title {
      display: flex;
      align-items: center;

      button {
        width: 48px;
        height: 48px;
        background-color: #edeff1;
        border-radius: 100%;
        border: none;
        position: relative;
        cursor: pointer;

        svg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      h1 {
        margin-left: 16px;
        line-height: 46px;
      }
    }

    .fixed-asset-ledger_header-btn {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;

      .ant-btn {
        height: 48px;
        border-radius: 7px;
        font-weight: var(--font-bold);
      }

      .ant-btn {
        color: var(--color-primary);
        border-color: var(--color-primary);
        min-width: 160px;
      }
    }
  }

  .fixed-asset-ledger_form {
    .ant-form-item {
      margin-bottom: 0;

      .ant-form-item-label {
        padding: 0 0 4px;

        label {
          font-weight: var(--font-normal);
        }
      }

      .ant-select-lg,
      .ant-input-lg,
      .ant-picker-large {
        height: 44px;
      }
    }

    .ant-select-selection-placeholder,
    input::placeholder {
      font-size: var(--font-size-sm);
      font-weight: var(--font-medium);
      color: var(--color-border-primary);
    }

    .fixed-asset-ledger_form-month {
      margin-bottom: 12px;

      .fixed-asset-ledger_form-fiscal-month {
        width: auto;
      }
    }

    .fixed-asset-ledger_form-filters-row {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      overflow-x: auto;
      padding-bottom: 8px;

      .fixed-asset-ledger_search-btn.ant-btn {
        flex-shrink: 0;
        height: 44px;
        min-width: 88px;
        font-weight: 700;
        background-color: var(--color-primary);
        color: #ffffff;
        border: none;
        border-radius: 7px;
        &:hover {
          background-color: var(--color-hover-primary) !important;
          color: #ffffff !important;
        }
      }
    }

    .fixed-asset-ledger_form-status {
      width: 120px;
      min-width: 120px;
    }

    .fixed-asset-ledger_form-asset-no {
      width: 130px;
      min-width: 130px;
    }

    .fixed-asset-ledger_form-company,
    .fixed-asset-ledger_form-store {
      width: 200px;
      min-width: 200px;
    }

    .fixed-asset-ledger_form-category,
    .fixed-asset-ledger_form-department,
    .fixed-asset-ledger_form-ownership {
      width: 150px;
      min-width: 150px;
    }

    .fixed-asset-ledger_form-photo {
      width: 120px;
      min-width: 120px;
    }

    .fixed-asset-ledger_form-date-stack,
    .fixed-asset-ledger_form-price-stack {
      width: 150px;
      min-width: 150px;
    }

    .fixed-asset-ledger_stack-field {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .ant-picker,
      .ant-input {
        width: 100%;
      }

      .ant-form-item-explain {
        display: none !important;
      }
    }

    .fixed-asset-ledger_form-footer {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 8px;

      .fixed-asset-ledger_search-warning {
        color: #ff4d4f;
        font-size: var(--font-size-sm);
      }

      .fixed-asset-ledger_form-object {
        height: 44px;
        min-width: 180px;
        padding: 10px 12px;
        border: 1px solid var(--color-border-primary);
        background-color: var(--color-border-secondary);
        border-radius: 8px;
        font-size: var(--font-size-base);
        font-weight: var(--font-medium);
        line-height: 24px;
      }
    }
  }

  .fixed-asset-ledger_table {
    margin-top: 20px;

    .ant-table-container {
      border-end-end-radius: 8px;
      border-end-start-radius: 8px;
      border-start-end-radius: 0;
      border-top: none !important;

      .ant-table-thead {
        .ant-table-cell {
          padding: 16px 8px;
          border-top: 1px solid var(--color-border-primary);
          border-bottom: 4px solid var(--color-border-primary) !important;
        }

        .ant-table-column-sort {
          background: var(--background-header-table);
        }

        .ant-table-cell-scrollbar {
          background-color: var(--color-white);
          border-inline-end: none !important;
        }
      }

      .ant-table-tbody {
        height: ${(props) => (props.listdata > 0 ? 'unset' : '590px')};

        .ant-table-tbody-virtual-holder {
          max-height: 580px !important;
        }

        .ant-table-row:last-child {
          .ant-table-cell:first-child {
            border-end-start-radius: 8px;
          }

          .ant-table-cell:last-child {
            border-end-end-radius: 8px;
          }
        }

        .ant-table-cell {
          font-weight: var(--font-medium);
          background-color: var(--color-white);
          padding: 14px 8px;

          .all-device_ellipsis {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }

          .all-device_link {
            color: var(--color-link);
            cursor: pointer;
          }

          .all-device_action-icon {
            color: var(--color-link);
            cursor: pointer;
            font-size: 16px;
          }

          .all-device_action-icon-danger {
            color: #f04438;
          }
        }

        .ant-table-placeholder {
          .ant-table-cell {
            background-color: #f9fafb !important;
            border-end-end-radius: 8px;
            border-end-start-radius: 8px;

            .ant-empty-image {
              height: 200px !important;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .fixed-asset-ledger_header {
      .fixed-asset-ledger_header-btn {
        width: 100%;
      }
    }
  }
`;

export const ConfirmModalWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    background: var(--color-white);
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.08);
    border-radius: 12px;
  }

  .ant-modal-header {
    margin-bottom: 0;
    padding: 16px 24px;
    background: none;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
      line-height: 24px;
    }
  }

  .ant-modal-footer {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    column-gap: 16px;
    padding: 12px 24px 24px;
    margin-top: 0;

    .ant-btn {
      width: 202px;
      height: 48px;
      box-shadow: none;
      font-weight: var(--font-bold);
      margin-inline-start: 0;
    }

    .ant-btn-default {
      color: var(--color-primary);
      border-color: var(--color-primary);
    }
  }

  .ant-modal-body {
    padding: 0 24px;
    border-bottom: 1px solid #f1f3f7;
    border-top: 1px solid #f1f3f7;
    text-align: center;

    .fixed-asset-ledger_modal-download {
      margin: 30px 0 24px;
      font-weight: var(--font-medium);
    }
  }
`;
